// extracted by mini-css-extract-plugin
module.exports = {"top":"PrivacyPolicy_top__RSFI6","content":"PrivacyPolicy_content__FRo3Q"};